import type { AppVersions, ConnectwareLicense, Metrics, SystemConnectivity } from '../../domain'

/**
 * Service to fetch information important to the system
 *
 * Such as the connectivity of it to the backend services, versioning or license
 */
export interface SystemService {
    getUIVersion(): string
    fetchVersions(): Promise<AppVersions>

    fetchConnectivity(): Promise<SystemConnectivity>

    fetchLicense(): Promise<ConnectwareLicense>

    /**
     * @throw ConnectwareError
     *  if the `ConnectwareError['type']` is CONFIGURATION_ERROR, it means an issue with the configured license
     */
    refreshLicense(): Promise<void>

    /**
     * @throw ConnectwareError
     *  if the `ConnectwareError['type']` is CONFIGURATION_ERROR, it means an issue with the configured license
     */
    uploadLicenseFile(content: string): Promise<void>

    /**
     * @throw ConnectwareError
     */
    fetchMetrics(): Promise<Metrics>

    /* @throw ConnectwareError
     * Send all not transmitted metrics to the portal if connection is available
     */
    sendMetricsToPortal(): Promise<void>
}
